import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="mt-24 border-t border-[#efe6d2] text-foreground"
      style={{ background: "linear-gradient(180deg, #ffffff 0%, #fff8f2 55%, #fdeee9 100%)" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block rounded-2xl bg-white p-3 mb-5 border border-[#efe6d2] shadow-sm transition-transform hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#c59b27]" data-testid="footer-logo-home-link">
              <img src="/assets/ethos-research-labs-logo.webp" alt="Ethos Research Labs — home" width="990" height="509" className="w-44 h-auto object-contain" data-testid="footer-logo" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Research materials and reconstitution solutions for in-vitro laboratory research. Certificate availability is listed in our COA directory.
            </p>
          </div>
          <div>
            <p className="eyebrow mb-4 text-champagne">Shop</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/shop" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-shop-link">All products</Link></li>
              <li><Link to="/shop" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-bundles-link">Bundle &amp; Save</Link></li>
              <li><Link to="/coa" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-coa-link">Certificates of Analysis</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-4 text-champagne">Support</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/faq" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-faq-link">FAQ</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-contact-link">Contact</Link></li>
              <li><Link to="/track" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-track-link">Track order</Link></li>
              <li><Link to="/affiliates" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-affiliates-link">Affiliates</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-4 text-champagne">Legal</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/terms" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/shipping" className="text-muted-foreground hover:text-champagne transition-colors" data-testid="footer-shipping-link">Shipping &amp; Returns</Link></li>
            </ul>
            <p className="text-xs text-muted-foreground/80 leading-relaxed mt-5">
              For in-vitro laboratory and research use only. Not for human or veterinary use. Not FDA-evaluated.
            </p>
          </div>
        </div>
        <div className="border-t border-[#efe6d2] mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Ethos Research Labs. For research use only.</span>
        </div>
      </div>
    </footer>
  );
}
